import { actionCreatorFactory } from 'typescript-fsa'
import { DayLogs } from '../../types'

const actionCreator = actionCreatorFactory()

export const receiveLogs = actionCreator<DayLogs>('receiveLogs')
